<template>
  <div class="homePage position-relative">
    <Loader v-if="loading" />

    <div v-else>
      <div v-if="noData">
        <p class="text-center">
          {{ $t("labels.welcomeMsg") }}
        </p>
      </div>
      <NoData v-if="noData" />

      <div class="" ref="main_wrapper" v-else>
        <div class="row fadeIn">
          <!-- End:: Aside -->
          <div class="col-12">
            <main>
              <div class="row m-0 mb-2">
                <div
                  class="col-md-6 p-2 col-lg-4 col-xl-3"
                  v-for="(card, index) in cards"
                  :key="index"
                >
                  <simple-card classes="w-100  h-100 this">
                    <statistics-card
                      :item="card"
                      :color="getRandomColor(colors)"
                    />
                  </simple-card>
                </div>
              </div>
            </main>
          </div>
        </div>
        <button class="chatIcon" @click="open = true">
          <v-icon> fal fa-comment </v-icon>
        </button>
        <base-model :show="open" @close="open = false" name="fadeIn">
          <div class="chat_app mx-1 row" @click.stop="uplodesActive = false">
            <div
              @click="toggleMenu"
              class="overlay"
              :class="{ active: menuActive }"
            ></div>

            <div class="friends_col col-md-4 col-xl-3 col-12">
              <div class="friends" :class="{ active: menuActive }">
                <span @click="toggleMenu" class="closeMenu"
                  ><i class="far fa-times"></i
                ></span>

                <header class="friends_header">
                  <!-- <v-autocomplete
                ref="autocomplete"
                :items="users"
                clearable
                :search-input.sync="autocomplete_text"
                @input="getUsers($event)"
                :item-text="nameWithCode"
                item-value="id"
                :label="$t('labels.startChat')"
              ></v-autocomplete> -->
                  <base-input
                    type="text"
                    @blur="getUsers($event)"
                    @enter="getUsers($event)"
                    v-model="autocomplete_text"
                    :placeholder="$t('labels.startChat')"
                  ></base-input>
                </header>

                <ul class="chats">
                  <!-- <h3>المحادثات</h3> -->
                  <li
                    class="chat"
                    :class="{ active: chat.isActive }"
                    v-for="(chat, index) in filterChats"
                    :key="chat.id"
                    @click="set_active(chat.id)"
                  >
                    <div class="chat_content">
                      <div class="image">
                        <img
                          :src="chat.owner?.image"
                          @error="defaultImage(index)"
                          alt="..."
                        />
                        <span
                          class="status"
                          :class="{
                            offline: !chat.online,
                            online: chat.online,
                          }"
                        ></span>
                      </div>
                      <div
                        class="user_info"
                        :class="{ newMessage: !chat.is_read }"
                      >
                        <h3 class="friend_name">{{ chat.owner.full_name }}</h3>
                        <read-more
                          v-if="chat.messages"
                          class="readMore chat_msg"
                          more-str=""
                          :text="
                            chat.messages[0].message_type == 'image'
                              ? 'image'
                              : chat.messages[0].message_type == 'video'
                              ? 'video'
                              : chat.messages[0].message
                          "
                          link="#"
                          less-str=""
                          :max-chars="22"
                        ></read-more>
                      </div>
                    </div>
                    <div class="time_messages">
                      <span class="time">{{ chat.messages[0].time_age }}</span>
                      <span class="num_of_messages" v-if="!chat.is_read"></span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            <div class="chatbox_col col-md-8 col-xl-9 col-12">
              <div class="chat_box">
                <header class="chat_box_header">
                  <div class="user">
                    <span @click="toggleMenu" class="menu_icon"
                      ><i class="far fa-bars"></i
                    ></span>
                    <div class="image" v-if="activeUser">
                      <img :src="activeUser.owner?.image" alt="..." />
                      <!-- <span class="status online"></span> -->
                    </div>
                    <h3 class="name" v-if="activeUser">
                      {{ activeUser.owner.full_name }}
                    </h3>
                  </div>
                  <!-- <span
                @click="toggleFave"
                class="isFave"
                :class="{ active: this.isFave }"
                ><i class="far fa-star"></i
              ></span> -->
                </header>

                <div
                  class="chat_view"
                  v-chat-scroll="{
                    always: true,
                    smooth: true,
                    scrollonremoved: true,
                  }"
                >
                  <div v-if="activeUser" :class="{ 'p-2': activeUser }">
                    <div
                      v-for="message in messages"
                      :key="message.id"
                      class="d-flex flex-column"
                    >
                      <div
                        class="messageOwner"
                        :class="{
                          sender: message.is_me,
                          receiver: !message.is_me,
                        }"
                      >
                        <!-- {{ message.sender.image }} -->
                        <img :src="message.sender.image" />
                        <div class="content">
                          <p
                            v-if="
                              message.message_type == 'text' ||
                              message.message_type == 'complaint'
                            "
                            class="text d-flex align-items-center"
                          >
                            <a
                              v-if="isURL(message.message)"
                              target="_blank"
                              style="text-decoration: underline"
                              :href="message.message"
                              >{{ message.message }}</a
                            >
                            <span v-else>
                              {{ message.message }}
                            </span>
                          </p>

                          <p
                            class="text d-flex align-items-center"
                            v-if="message.message_type == 'file'"
                          >
                            <a
                              class="d-flex"
                              target="_blank"
                              :href="message.path"
                              download
                              ><i class="far fa-file fs-2"></i>
                              <span v-html="message.path" class="mx-4"></span>
                            </a>
                          </p>

                          <div v-else class="media d-flex align-items-center">
                            <div
                              v-if="message.message_type == 'image'"
                              class="image"
                            >
                              <img
                                width="200"
                                class="img-fluid"
                                @click="openModel(message.message)"
                                :src="message.path"
                              />
                              <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                            </div>

                            <div
                              v-if="message.message_type == 'video'"
                              class="video d-flex align-items-center"
                            >
                              <video controls>
                                <source :src="message.path" type="video/mp4" />
                              </video>
                              <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                            </div>
                            <div v-if="message.message_type == 'location'">
                              <base-map1
                                :draggable="false"
                                :biggingMarkers="getLatLng(message.message)"
                              />
                              <!-- <p v-if="message.descreption" class="descreption">
                        {{ message.descreption }}
                      </p> -->
                            </div>

                            <div
                              v-if="message.message_type == 'audio'"
                              class="audio_media d-flex align-items-center"
                            >
                              <audio controls>
                                <source :src="message.path" type="audio/ogg" />
                              </audio>
                            </div>
                          </div>
                        </div>
                        <span class="d-block time mx-2">{{
                          message.sent_on
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-else>
                <img
                  src="@/assets/media/images/no-data.svg"
                  class="img-fluid w-100"
                  alt=""
                />
              </div> -->
                </div>

                <!-- <transition name="fadeInUp">
              <div v-if="showPreview_image" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <img
                  class="preview_img img-fluid preview_media"
                  width="100"
                  height="100"
                  @click="openModel(data.file_image_src)"
                  :src="data.file_image_src"
                  alt="..."
                />
              </div>
            </transition> -->

                <transition name="fadeInUp">
                  <div v-if="showPreview_image" class="uplode_preview">
                    <span @click="close_preview" class="close"
                      ><i class="far fa-times"></i
                    ></span>
                    <img
                      class="preview_img img-fluid preview_media"
                      width="100"
                      height="100"
                      @click="openModel(data.avatar.preview)"
                      :src="data.avatar.preview"
                      alt="..."
                    />
                  </div>
                </transition>

                <transition name="fadeInUp">
                  <div v-if="showPreview_video" class="uplode_preview">
                    <span @click="close_preview" class="close"
                      ><i class="far fa-times"></i
                    ></span>
                    <video class="preview_video preview_media" controls>
                      <source :src="data.video.preview" type="video/mp4" />
                    </video>
                  </div>
                </transition>

                <transition name="fadeInUp">
                  <div v-if="showPreview_audio" class="uplode_preview">
                    <span @click="close_preview" class="close"
                      ><i class="far fa-times"></i
                    ></span>
                    <audio class="preview_img preview_media" controls>
                      <source :src="data.audio.preview" type="audio/ogg" />
                    </audio>
                  </div>
                </transition>

                <!-- <transition name="fadeInUp">
              <div v-if="showPreview_video" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <video class="preview_video preview_media" controls>
                  <source :src="data.file_video_src" type="video/mp4" />
                </video>
              </div>
            </transition> -->
                <!-- <transition name="fadeInUp">
              <div v-if="showPreview_map" class="uplode_preview">
                <span @click="close_preview" class="close"
                  ><i class="far fa-times"></i
                ></span>
                <base-map1 @getLocation="getLocation" />
              </div>
            </transition> -->
                <footer class="chat_footer" v-if="activeUser">
                  <!-- ====== Send_button ===== -->
                  <div class="chat_footer_container">
                    <textarea
                      ref="message_text"
                      v-model="data.message_text"
                      :placeholder="$t('labels.typeHere')"
                      v-on:keydown.enter="send_message('text', $event)"
                    ></textarea>
                    <button @click="send_message('text')" class="send_button">
                      <span><i class="fas fa-paper-plane"></i></span>
                    </button>
                  </div>

                  <div class="attachments">
                    <button @click.stop="toggleUplodes" class="icon">
                      <i class="far fa-paperclip"></i>
                    </button>
                    <!-- <transition name="fadeInUp"> -->
                    <ul v-if="uplodesActive" @click.stop class="uplode_options">
                      <!-- <li>
                    <input
                      class="upload_image uplode_Input"
                      type="file"
                      id="upload_image"
                      @change="uploadImage"
                    />
                    <label for="upload_image"
                      ><i class="far fa-image-polaroid"></i
                    ></label>
                  </li> -->
                      <li>
                        <input
                          class="upload_image uplode_Input"
                          type="file"
                          id="upload_image"
                          @change="uploadImage($event, 'messages', 'avatar')"
                          accept="image/*"
                        />
                        <label for="upload_image"
                          ><i class="far fa-image-polaroid"></i
                        ></label>
                      </li>
                      <li>
                        <input
                          class="uplode_video uplode_Input"
                          type="file"
                          id="uplode_video"
                          name="uplode_video"
                          accept="video/*"
                          @change="uploadVideo($event, 'messages', 'video')"
                        />
                        <label for="uplode_video">
                          <i class="far fa-video"></i>
                        </label>
                      </li>
                      <li>
                        <input
                          class="uplode_audio uplode_Input"
                          type="file"
                          id="uplode_audio"
                          name="uplode_audio"
                          accept="audio/*"
                          @change="uploadAudio($event, 'messages', 'audio')"
                        />
                        <label for="uplode_audio">
                          <i class="far fa-music"></i>
                        </label>
                      </li>
                      <!-- <li>
                    <input
                      class="uplode_video uplode_Input"
                      type="file"
                      id="uplode_video"
                      name="uplode_video"
                      accept="video/*"
                      @change="upload_video"
                    />
                    <label for="uplode_video">
                      <i class="far fa-video-slash"></i>
                    </label>
                  </li> -->
                      <li>
                        <input
                          class="uplode_video uplode_Input"
                          type="file"
                          id="upload_file"
                          name="upload_file"
                          @change="uploadFile($event, 'messages', 'file')"
                        />
                        <label for="upload_file">
                          <i class="far fa-file"></i>
                        </label>
                      </li>
                      <!-- <li>
                    <input
                      class="uplode_video uplode_Input"
                      type="file"
                      id="upload_file"
                      name="upload_file"
                      @change="upload_file"
                    />
                    <label for="upload_file">
                      <i class="far fa-file"></i>
                    </label>
                  </li> -->
                      <!-- <li>
                    <a
                      role="button"
                      @click="showPreview_map = !showPreview_map"
                    >
                      <i class="fas fa-location-arrow"></i>
                    </a>
                  </li> -->
                    </ul>
                    <!-- </transition> -->
                  </div>
                </footer>
              </div>
            </div>

            <!-- Dialog -->
            <base-model @close="closeModel" :show="model.show_model">
              <div class="image">
                <img
                  class="img-fluid"
                  v-if="model.model_img_src"
                  :src="model.model_img_src"
                  alt="..."
                />
              </div>
            </base-model>
          </div>
        </base-model>
      </div>
    </div>
  </div>
</template>

<script>
import ChartsAside from "@/components/Layouts/ChartsAside.vue";
import Loader from "@/components/Loaders/loader.vue";

import AreaCharts from "@/components/Charts/AreaCharts.vue";
import ColumnChart from "@/components/Charts/ColumnChart.vue";

export default {
  name: "HomePage",

  components: {
    ChartsAside,
    AreaCharts,
    ColumnChart,
    Loader,
  },

  data() {
    return {
      colors: [
        {
          first: "#62EAE1",
          secound: "rgba(126, 229, 223, 0)",
        },
        {
          first: "#FF6370",
          secound: "rgba(255, 99, 112, 0)",
        },
        {
          first: "#9E62EA",
          secound: " #B199ED",
        },
        {
          first: "#EABC62",
          secound: "#E9BA62",
        },
      ],
      open: false,
      chat: false,
      autocomplete_text: "",
      search_text: "",

      messages: [],
      users: [],
      activeUser: null,
      chatId: null,
      // chats: [],
      // FormData
      data: {
        message_text: "",
        file_image_src: null,
        file_image: null,
        file_video_src: null,
        file_video: null,
        file_src: null,
        // file: null,
        location: null,
        avatar: {
          mainMedia: null,
          preview: null,
          image: null,
          mainPreviewUrl: null,
        },
        video: {
          mainMedia: null,
          preview: null,
          image: null,
          mainPreviewUrl: null,
        },
        file: {
          mainMedia: null,
          preview: null,
          image: null,
          mainPreviewUrl: null,
        },
        audio: {
          mainMedia: null,
          preview: null,
          image: null,
          mainPreviewUrl: null,
        },
      },

      model: {
        show_model: false,
        model_img_src: null,
      },

      showPreview_image: false,
      showPreview_file: false,
      showPreview_map: false,
      showPreview_video: false,
      showPreview_audio: false,
      uplodesActive: false,
      menuActive: false,
      isFave: false,
      // ========== Charts Aside
      asideIsActive: false,
      // start of main loader
      noData: true,
      loading: false,
      // end of main loader
      // ============ Charts Data
      cards: [],
      notifications_states: [],
      charts: [],
      top_cards: [],
      recently_partner: [],
      recently_rider: [],
      top_vehicle_package: [],
      top_partners: [],
      top_rider: [],
      chartsData: null,

      top_rider_headers: [
        {
          text: "الصورة",
          align: "center",
          value: "avatar",
          sortable: false,
        },
        {
          text: this.$t("labels.name"),
          value: "name",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("labels.email"),
          value: "email",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.phone"),
          align: "center",
          value: "phone_complete_form",
          sortable: false,
        },
        {
          text: this.$t("labels.activation"),
          align: "center",
          value: "is_active",
          sortable: false,
        },

        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],

      top_partners_headers: [
        {
          text: "الصورة",
          align: "center",
          value: "avatar",
          sortable: false,
        },
        {
          text: this.$t("labels.fullname"),
          value: "full_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("labels.email"),
          value: "email",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("labels.phone"),
          align: "center",
          value: "phone_complete_form",
          sortable: false,
        },
        {
          text: this.$t("labels.is_active"),
          align: "center",
          value: "is_active",
          sortable: false,
        },

        {
          text: this.$t("labels.control"),
          value: "actions",
          align: "center",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    isSmallScreen() {
      return this.$store.getters["sideNav_module/isSmallScreen"];
    },
    chats() {
      return this.$store.getters["chat_module/chats"].sort(
        (a, b) => b.last_message_created - a.last_message_created
      );
    },
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
    canRecord() {
      return this.data.message_text == "";
    },

    filterChats() {
      if (this.search_text == "") {
        return this.chats;
      } else {
        return this.chats.filter((chat) => {
          if (
            chat.owner.full_name
              .toLowerCase()
              .indexOf(this.search_text.toLowerCase()) > -1
          ) {
            return chat;
          }
        });
      }
    },
  },

  methods: {
    nameWithCode({ full_name }) {
      return `${full_name} `;
    },
    set_active(id) {
      this.menuActive = false;
      this.chatId = id;
      this.axios.post(`support_chats/${id}/markAsRead`);

      this.axios.get(`support_chats/${id}`).then((res) => {
        this.messages = res.data.data.messages.reverse();
      });

      let found = this.chats.find((el) => el.id == id);
      this.chats.map((chat) => {
        chat.isActive = false;
      });
      if (found) {
        this.activeUser = found;
        found.isActive = true;
        found.is_read = true;
      } else {
        this.$store.commit("chat_module/pushChat", {
          id: res.data.data.id,
          messages: "",
          last_message_created_at: "",
          isActive: true,
          last_message_created: new Date().getTime(),
          is_read: false,
          online: false,
          owner: res.data.data.user,
        });

        this.activeUser = {
          id: res.data.data.id,
          owner: res.data.data.user,
          isActive: true,
          online: false,
          is_read: false,
        };
      }

      this.receiveSocketNotification();
    },
    getLatLng(location) {
      try {
        return JSON.parse(location);
      } catch (error) {
        let data = location.split(",");

        return {
          lat: data[0],
          lng: data[1],
        };
      }

      // console.log(typeof location);
    },
    defaultImage(index) {
      this.chats[
        index
      ].owner.image = require("@/assets/media/images/Icons/no-data.svg");
    },
    isURL(str) {
      var res = str.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      ); // fragment locator
      return res !== null;
    },
    openModel(e) {
      this.model.show_model = true;
      this.model.model_img_src = e;
    },

    closeModel() {
      this.model.show_model = false;
    },

    toggleMenu() {
      this.menuActive = !this.menuActive;
    },

    toggleFave() {
      this.isFave = !this.isFave;
    },

    toggleUplodes() {
      this.uplodesActive = !this.uplodesActive;
    },

    close_preview() {
      this.showPreview_image = false;
      this.data.avatar.preview = null;
      this.data.avatar.image = null;
      this.data.video.image = null;
      this.data.audio.image = null;
      this.data.file.image = null;
      this.showPreview_video = false;
      this.data.video.preview = null;
      this.showPreview_audio = false;
      this.data.audio.preview = null;
      this.data.message_text = "";
      // this.showPreview_map = false;
      // this.data.file_image_src = null;
      // this.data.file = null;
      // this.data.location = null;
    },
    uploadImage(event, modal, varName) {
      if (event) {
        // this.btnLoading = true;
        const data = new FormData();
        data.append("file", event.target.files[0]);
        data.append("attachment_type", "image");
        data.append("model", modal);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_ATTACHMENTS_URL}attachments`,
          data: data,
        })
          .then((res) => {
            this.data[varName].image = res.data.data;
            console.log(this.data[varName].image);
            this.data[varName].preview = URL.createObjectURL(
              event.target.files[0]
            );
            this.data.message_text = res.data.data;

            this.showPreview_image = true;
          })
          .catch((err) => {
            this.$iziToast.error({
              title: this.$t("validation.error"),
              message: err.response.data.message,
            });

            // this.btnLoading = false;
          });
      }
    },
    uploadVideo(event, modal, varName) {
      if (event) {
        const data = new FormData();
        data.append("file", event.target.files[0]);
        data.append("attachment_type", "video");
        data.append("model", modal);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_ATTACHMENTS_URL}attachments`,
          data: data,
        })
          .then((res) => {
            this.data[varName].image = res.data.data;
            this.data[varName].preview = URL.createObjectURL(
              event.target.files[0]
            );
            this.data.message_text = res.data.data;

            this.showPreview_video = true;
          })
          .catch((err) => {
            this.$iziToast.error({
              title: err,
              message: err,
            });
          });
      }
    },
    uploadFile(event, modal, varName) {
      if (event) {
        const data = new FormData();
        data.append("file", event.target.files[0]);
        data.append("attachment_type", "file");
        data.append("model", modal);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_ATTACHMENTS_URL}attachments`,
          data: data,
        })
          .then((res) => {
            this.data[varName].image = res.data.data;
            this.data[varName].preview = URL.createObjectURL(
              event.target.files[0]
            );
            this.data.message_text = res.data.data;

            this.showPreview_file = true;
          })
          .catch((err) => {
            this.$iziToast.error({
              title: err,
              message: err,
            });
          });
      }
    },
    uploadAudio(event, modal, varName) {
      if (event) {
        const data = new FormData();
        data.append("file", event.target.files[0]);
        data.append("attachment_type", "audio");
        data.append("model", modal);

        this.axios({
          method: "POST",
          url: `${process.env.VUE_APP_BASE_ATTACHMENTS_URL}attachments`,
          data: data,
        })
          .then((res) => {
            this.data[varName].image = res.data.data;
            this.data[varName].preview = URL.createObjectURL(
              event.target.files[0]
            );
            this.data.message_text = res.data.data;

            this.showPreview_audio = true;
          })
          .catch((err) => {
            this.$iziToast.error({
              title: err,
              message: err,
            });
          });
      }
    },
    // uploadImage(e) {
    //   this.data.message_text = e.target.files[0].name;
    //   this.data.file_image_src = URL.createObjectURL(e.target.files[0]);
    //   this.data.file_image = e.target.files[0];
    //   this.uplodesActive = false;
    //   this.showPreview_image = true;
    //   this.uplodesActive = !this.uplodesActive;
    // },
    upload_file(e) {
      this.data.message_text = e.target.files[0].name;
      this.data.file = e.target.files[0];
      this.uplodesActive = !this.uplodesActive;
    },

    upload_video(e) {
      this.data.message_text = e.target.files[0].name;
      this.data.file_video_src = URL.createObjectURL(e.target.files[0]);
      this.data.file_video = e.target.files[0];
      this.uplodesActive = false;
      this.showPreview_video = true;
      this.uplodesActive = !this.uplodesActive;
    },

    after_recording(data) {
      this.send_message("sound", data.blob);
    },

    send_message(e, event) {
      if (event) {
        if (event?.keyCode == 13 && !event?.shiftKey) {
          event.preventDefault();
          if (!this.data.message_text) {
            return;
          }
        }
      } else {
        if (!this.data.message_text) {
          return;
        }
      }
      let data;
      let type = e;
      // if (this.data.file_image_src) {
      //   type = "image";
      //   data = this.data.file_image;
      // }
      if (this.data.avatar.image) {
        type = "image";
        data = this.data.avatar.image;
      }
      if (this.data.video.image) {
        type = "video";
        data = this.data.video.image;
      }
      if (this.data.file.image) {
        type = "file";
        data = this.data.file.image;
      }
      if (this.data.audio.image) {
        type = "audio";
        data = this.data.audio.image;
      }
      if (this.data.location) {
        type = "location";
        data = this.data.location;
      }
      const frmData = new FormData();
      frmData.append("message_type", type);
      if (this.data.location) {
        let data = {
          location: this.data.location.location,
          lat: this.data.location.center.lat,
          lng: this.data.location.center.lng,
        };

        frmData.append("message", JSON.stringify(data));
      } else {
        frmData.append("message", data ?? this.data.message_text);
      }

      this.axios
        .post(`support_chats/${this.activeUser.id}/reply`, frmData)
        .then((res) => {
          this.axios
            .post(`support_chats/${this.activeUser.id}/markAsRead`)
            .then((res) => {
              this.$store.dispatch("chat_module/getChats");

              // this.getChats();
              this.messages = res.data.data.messages.reverse();
            });

          // this.messages.push(res.data.data.messages)

          this.chats.last_message_created_at = res.data.data.messages.sent_on;

          this.close_preview();

          this.data.message_text = "";
          new Audio(
            require("../../assets/media/sounds/message_sent.mp3")
          ).play();
        })
        .catch((err) => {
          if (err.response.data.errors) {
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message: err.response.data.errors.message[0],
            });
          } else {
            this.$iziToast.error({
              displayMode: 2,
              title: this.$t("error"),
              message: err.response.data.message ?? err.response.data.messages,
            });
          }
        });
    },
    receiveSocketNotification() {
      var socket = io(process.env.VUE_APP_BASE_SOCKET_URL);

      // Driver Connection Chanel
      socket.on(`SupportNewMessage:${this.chatId}`, (payload) => {
        if (payload) {
          this.messages.push(payload);
          var audio = document.createElement("AUDIO");
          document.body.appendChild(audio);
          audio.src = require("@/assets/media/sounds/notification.mp3");
          audio.play();
          // new Audio(require("@/assets/media/sounds/notification.mp3")).play();
        }
      });
    },
    getUsers(event) {
      if (event) {
        this.axios.get(`support_chats/${event}`).then((res) => {
          this.autocomplete_text = "";
          this.set_active(res.data.data.id);
          this.$refs.autocomplete.reset();
        });

        return;
      }
      this.search_text = this.autocomplete_text;

      // this.axios
      //   .get(`search_in_users?key_word=${this.autocomplete_text ?? ""}`)
      //   .then((res) => (this.users = res.data.data));
    },

    getLocation(e) {
      this.data.message_text = e.location;
      this.data.location = e;
    },
    toggleAside() {
      this.asideIsActive = !this.asideIsActive;
    },
    getRouteLink(item) {
      let link;
      if (item.notify_type == "new_trip") {
        link = "trips";
      } else if (item.notify_type == "new_rider") {
        link = "riders";
      } else if (item.notify_type == "new_partner") {
        link = "partners";
      } else if (item.notify_type == "finish_trip") {
        link = "trips";
      }

      return link;
    },
    getHome() {
      this.canShow = this.$permission.allowed("home/show");
      // if (!this.canShow) {
      //   this.loading = true;
      //   this.noData = false;
      //   this.axios({
      //     method: "GET",
      //     url: "financial_reports",
      //   })
      //     .then((res) => {
      //       this.noData = false;
      //       this.loading = false;
      //       this.cards = [];
      //       for (const [key, value] of Object.entries(res.data.data)) {
      //         this.cards.push({
      //           title: this.$t(key),
      //           count: value,
      //         });
      //       }
      //     })
      //     .catch((err) => {
      //       this.noData = true;
      //       this.loading = false;
      //       this.$iziToast.error({
      //         displayMode: 2,
      //         title: this.$t("error"),
      //         message:
      //           err.response?.data.message ?? err.response?.data.messages,
      //       });
      //     });
      // }
    },

    getRandomColor(colors) {
      let random = Math.floor(Math.random() * 4);

      return { colors: colors[random], id: random };
    },

    imageError(index, inp) {
      this[inp][
        index
      ].avatar = require("@/assets/media/images/Icons/no-data.svg");
    },

    getPermissions() {
      this.axios.get("get_my_permissions").then((res) => {
        localStorage.setItem(
          "efaa_dash_permissions",
          JSON.stringify(res.data.data)
        );
        this.getHome();
        this.getSideBar();
      });
    },

    // getControls() {
    //   this.axios
    //     .get("get_my_control_permissions")
    //     .then((res) =>
    //       localStorage.setItem(
    //         "efaa_dash_provider_controls",
    //         JSON.stringify(res.data.data)
    //       )
    //     );
    // },

    getSideBar() {
      this.axios.get("admin_side_bar").then((res) => {
        this.$router.push(`/${res.data[0].categories[0].permissions[0].url}`);
      });
    },
  },

  watch: {
    ["autocomplete_text"]() {
      this.getUsers();
    },
  },

  // mounted() {
  //   this.canAdd = this.$permission.allowed("cities/add");
  //   this.canEdit = this.$permission.allowed("cities/edit");
  //   this.canShow = this.$permission.allowed("cities/show");
  //   if (this.id) {
  //     if (!this.canAdd) {
  //       if (!this.canShow) {
  //         this.getUsers();
  //         this.axios.get(`support_chats/${this.id}`).then((res) => {
  //           this.autocomplete_text = "";

  //           this.set_active(res.data.data.id);
  //           this.$refs.autocomplete.reset();
  //         });
  //       }
  //     } else {
  //       this.$router.push({ path: `/permission-required` });
  //     }
  //   } else if (this.canAdd) {
  //     this.$router.push({ path: `/permission-required` });
  //   }
  // },

  created() {
    if (this.user.usertype != "superadmin") {
      // this.getPermissions();
      // this.getControls();
    } else {
      // if (localStorage.getItem("efaa_dash_permissions")) {
      //   localStorage.removeItem("efaa_dash_permissions");
      // }
      this.getHome();
    }
  },
};
</script>

<style lang="scss">
.homePage {
  .baseModel .main {
    width: 80% !important;
    overflow: auto;
  }
  .chat_box {
    overflow: auto;
  }
}
.chatIcon {
  position: fixed;
  bottom: 20px;
  inset-inline-end: 20px;
  width: 64px;
  height: 64px;
  background-color: var(--main);
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  .v-icon {
    color: white !important;
    font-size: 28px;
  }
}
.simple_card.this {
  min-height: 190px !important;
  margin-block: 0px !important;

  margin-inline-end: 0px !important;
}
.stats_chart {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  // justify-content: space-c;
  padding: 15px;
  gap: 1rem;
  // flex-direction: row-reverse;
  .icon {
    width: 50px;
    height: 50px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    word-break: break-word;
    .value {
      font-style: normal;
      font-weight: 500;
      font-size: 22px;
      line-height: 27px;
      color: #000;
    }

    .name {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      margin-bottom: 8px;
      color: var(--mainText);
    }

    .values {
      margin-top: 0.5rem;

      span {
        color: var(--main);
        font-weight: 700;
        font-size: 1rem;
      }
    }
  }
}

.notifications_states {
  header {
    border-bottom: 1px solid #efefef !important;

    .title {
      font-style: normal;
      font-weight: 400;
      font-size: 16px !important;
      line-height: 20px;
      color: #000;
    }
  }

  .content {
    min-height: 200px;
    max-height: 250px;
    overflow-y: auto;
    padding-block: 8px;

    .notification_card {
      .state {
        display: flex;
        align-items: center;

        .notification_content {
          margin-inline-start: 8px;

          .title {
            display: block;
            font-style: normal;
            font-weight: 400;
            font-size: 12px !important;
            line-height: 17px;
            color: #000;
            margin: 0;
            margin-bottom: 5px;
          }

          p,
          a {
            font-style: normal;
            font-weight: 400 !important;
            font-size: 10px !important;
            line-height: 15px;
            color: var(--mainText);
            margin: 0;
          }
        }

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }

      .no-data {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        h4 {
          font-size: 18px !important;
        }
      }
    }
  }

  footer {
    text-align: center;
    border-top: 1px solid #efefef !important;

    a {
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 17px;
      color: var(--mainText);
    }
  }

  &.client {
    .content {
      min-height: 250px;
      max-height: 250px;
    }
  }
}
.messages_cotroller {
  // border: 1px solid var(--mainText);
  background: var(--main);
  color: white;
  padding: 0.7rem 1rem;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  // padding: 5px 8px;
  span {
    font-size: 14px;
  }
  &.receiver {
    background: var(--main);
  }
  &.sender {
    background: var(--mainColor-2);
  }
}
.v-autocomplete.v-input > .v-input__control > .v-input__slot {
  margin: 0 !important;

  padding-top: 10px;
}
</style>
